import { Navigate } from 'react-router-dom';
import { Suspense, lazy, ComponentType } from 'react';
import BaseLayout from './components/layout/base-layout';
import SuspenseLoader from './components/global/suspense-loader';

type LoaderProps = {
  [key: string]: any;
};

const Loader = (Component: ComponentType<any>) => (props: LoaderProps) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Home = Loader(lazy(() => import('./pages/home')));
const Users = Loader(lazy(() => import('./pages/users')));
const Communities = Loader(lazy(() => import('./pages/communities')));
const Posts = Loader(lazy(() => import('./pages/posts')));
const Events = Loader(lazy(() => import('./pages/events')));
const UserEvents = Loader(lazy(() => import('./pages/user-events')));
const Coupons = Loader(lazy(() => import('./pages/coupons')));
const Accounts = Loader(lazy(() => import('./pages/accounts')));
const Settings = Loader(lazy(() => import('./pages/settings')));
const Login = Loader(lazy(() => import('./pages/login')));
const Status404 = Loader(lazy(() => import('./pages/status/not-found')));
const Status500 = Loader(lazy(() => import('./pages/status/server-error')));
const StatusMaintenance = Loader(lazy(() => import('./pages/status/maintenance')));

const routes = (isAuthenticated: boolean) => [
  {
    path: '/',
    element: isAuthenticated ? <BaseLayout /> : <Navigate to="/login" />,
    children: [
      { path: 'home', element: <Home /> },
      { path: 'users', element: <Users /> },
      { path: 'communities', element: <Communities /> },
      { path: 'posts', element: <Posts /> },
      { path: 'events', element: <Events /> },
      { path: 'user-events', element: <UserEvents /> },
      { path: 'coupons', element: <Coupons /> },
      { path: 'accounts', element: <Accounts /> },
      { path: 'settings', element: <Settings /> },
      { path: '*', element: <Status404 /> },
    ]
  },
  { path: 'login', element: isAuthenticated ? <Navigate to="/home" /> : <Login /> },
  { path: '404', element: <Status404 /> },
  { path: '500', element: <Status500 /> },
  { path: 'maintenance', element: <StatusMaintenance /> },
  { path: '*', element: <Navigate to="/404" /> }
];

export default routes;
